import React from "react";
import ItemGird from "../../compoments/shopper/ItemGird";
import {useNavigate} from "react-router-dom";

export default function Overview() {
    const navigate = useNavigate();

    return (<ItemGird onItemClick={(item) => navigate("/shopper/item/" + item.id)}/>)
}